import { Box } from '@lego/klik-ui';
import type { ReactElement, ReactNode } from 'react';
import { DetailsHeader } from '@/components/common';
import { DetailsSection } from '@/components/common/details/DetailsSection';

export type EditableFieldEditorProps = {
  value: string;
  onChange: (value: string) => void;
};

export type DetailSectionItem = {
  documentationLink?: string;
  body: ReactNode;
  editableValue?: string;
  renderEditor?: (props: EditableFieldEditorProps) => ReactNode;
};

export type DetailSectionProps = {
  title?: string;
  items: Record<string, DetailSectionItem>;
};

type Props = {
  title: string;
  sections: DetailSectionProps[];
  additionalComponent?: ReactElement;
};

export const DetailsBox = ({ title, sections, additionalComponent }: Props) => (
  <Box background="white" boxShadow="md" padding={6} rounded="md" width={{ base: '100%' }}>
    <DetailsHeader title={title} />
    {sections.map((section, idx) => (
      <DetailsSection key={section.title || `section-${idx}`} section={section} />
    ))}
    {additionalComponent}
  </Box>
);
